import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "twitter",
  "use": "twitter-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"twitter\"><path d=\"m.06 0 9.65 13.24L0 24h2.19l8.5-9.42L17.56 24H25L14.8 10.02 23.85 0h-2.19l-7.83 8.68L7.5 0zM3 2h3.5L22 23h-3.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol